import 'rxjs/add/operator/debounceTime';
import {Component} from '@angular/core';
import {NavController, NavParams} from 'ionic-angular';

import {CONFIG} from '../../../app/config';
import {ENUM, TAction, TDevicerBios} from "../../../app/enum";
import {TGoogleAnalytic, TStatusBar, Util} from "../../../app/util";

import {LogadoService} from '../../../providers/logado-service';
import {ProfileService} from "../../../providers/profile-service";

import {ProfileRepository} from "../../../repositories/profile-repository";

@Component({
    selector: 'page-conexao-menu',
    templateUrl: 'conexao-menu.html',
    providers: [ProfileService, ProfileRepository]
})
export class ConexaoMenuPage {

    TDevicerBios: any = TDevicerBios;

    enum: any;
    config: any;
    logado: any;

    etapa: number;

    devicers: any;

    constructor(public navCtrl: NavController, public navParams: NavParams,
                public util: Util,
                public logadoService: LogadoService,
                public profileService: ProfileService, public profileRepository: ProfileRepository) {

        this.enum = ENUM;
        this.config = CONFIG;
        this.logado = this.logadoService.getAuth();

        this.etapa    = this.util.anyParams(0, this.navParams.get('etapa'));
        let profileID = this.util.anyParams(0, this.navParams.get('profileID'));
        let hotspotID = this.util.anyParams(0, this.navParams.get('hotspotID'));

        /* Google Analytics */
        this.util.googleAnalytic(TGoogleAnalytic.gaPageview, 'Profile Menu', '/profile-menu');

        if (this.etapa == 0) this.devicerLoad(profileID, hotspotID);

    }

    ionViewDidEnter() {

        this.util.statusBarColor(TStatusBar.sbStyleDefault);

    }

    devicerLoad(profileID, hotspotID) {

        let loading = this.util.loadingDots();
        loading.present();

        this.profileService.devicer(TAction.acLoad, 0, profileID, hotspotID)
            .finally(() => loading.dismiss())
            .subscribe(
                data => this.devicers = data.Devicers,
                erro => this.util.alertResult(erro, () => this.dismiss()));

    }

    logout(devicer) {

        this.profileRepository.logout(this.navCtrl, true, devicer.DevicerID, devicer.DevicerThis)
            .subscribe( data => {

                let index = this.devicers.findIndex(DE => DE.DevicerID == devicer.DevicerID);
                this.devicers.splice(index, 1);

            });

    }

    dismiss() {

        this.navCtrl.pop();

    }

}



// WEBPACK FOOTER //
// ./src/pages/sync/conexao-menu/conexao-menu.ts